import React from 'react';
import { bool, func, instanceOf, string } from 'prop-types';
import { Box, Typography } from '@mui/material';

// TODO: maybe move this util
import { getSignalGroupAndName } from '../../../../scenes/Application/components/Webhooks/components/WebhookForm/util';
import Checkbox from '../../../Checkbox';

const SignalCheckbox = ({
  displayName,
  description,
  signalKey,
  handleSignalClick,
  selectedSignals,
  required,
}) => {
  const { signalGroup } = getSignalGroupAndName(signalKey);

  return (
    <Box pt={1} pr={2} pb={1.5} pl={2}>
      <Checkbox
        label={
          <React.Fragment>
            <Typography variant="body2" sx={theme => ({ fontFamily: theme.typography.bold.fontFamily })}>
              {displayName}
            </Typography>
            {description && <Typography variant="caption">{description}</Typography>}
          </React.Fragment>
        }
        checked={
          required ||
          selectedSignals.has(`${signalGroup}.*`) ||
          selectedSignals.has(signalKey)
        }
        onChange={() => handleSignalClick(signalKey)}
        disabled={required}
      />
    </Box>
  );
};

export default SignalCheckbox;

SignalCheckbox.propTypes = {
  displayName: string.isRequired,
  signalKey: string.isRequired,
  description: string,
  handleSignalClick: func.isRequired,
  selectedSignals: instanceOf(Set).isRequired,
  required: bool,
};

SignalCheckbox.defaultProps = {
  description: null,
  required: false,
};
